<div>
  <hr />
  <p class="text-center">{{copyright}}</p>
</div>
